import { useState } from 'react';

const FloatingCallButton = () => {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center justify-end">
      {/* Label */}
      <div
        className={`mr-3 bg-gray-900 text-white text-sm font-medium px-3 py-1.5 rounded-lg whitespace-nowrap transition-all duration-300 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 pointer-events-none'
        }`}
      >
        Bel ons
        <div className="absolute right-[-4px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-l-4 border-transparent border-l-gray-900"></div>
      </div>

      {/* Button */}
      <a
        href="tel:+31616708612"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="relative w-14 h-14 bg-orange-500 hover:bg-orange-600 rounded-full flex items-center justify-center shadow-lg shadow-orange-500/40 transition-all duration-200 hover:scale-110 cursor-pointer"
        aria-label="Bel ons"
      >
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-orange-500 animate-ping opacity-30"></span>
        <i className="ri-phone-fill text-white text-2xl relative z-10"></i>
      </a>
    </div>
  );
};

export default FloatingCallButton;
